import { errorPatterns } from "./errorPatterns";
import { errorTranslations } from "./errorTranslations";

export function errorTranslator(mensagem: string, lang: string = "pt-BR"): string {
  for (const pattern of errorPatterns) {
    const match = mensagem.match(pattern.regex);
    if (match) {
      if (errorTranslations[pattern.key]) {
        const translation = errorTranslations[pattern.key][lang];
        if (!translation) return "Erro desconhecido.";

        let formattedMessage = translation;
        pattern.placeholders.forEach((placeholder, index) => {
          formattedMessage = formattedMessage.replace(`{${placeholder}}`, match[index + 1]);
        });
        return formattedMessage;
      }
    }
  }
  return "";
}
